import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
    name: 'thumbnailUrl',
    standalone: false
})
export class ThumbnailUrlPipe implements PipeTransform {
  transform(data, type): string {
    if (data) {
      return environment.systemUrl + data + '.thumb';
    }
    else {
      switch (type) {
        case "image":
          return "./assets/img/noImage.png";
        case "audio":
          return "./assets/img/empty.mp3";
        case "video":
          return "./assets/img/empty.mp4";
      }
    }
    return null;
  }

}